// slick default setting
let defaulsettings = {
    loop: true,
    speed: 700,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    navigation: {
        nextEl: '.swiper-prev',
        prevEl: '.swiper-next'
    },
    autoplay: {
        delay: 5000,
        disableOnInteraction: false
    }
};

// start slider default
let allSwipper = [];

function initAllSwipers() {
    document.querySelectorAll('.swiper-slider').forEach((element, i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`, "");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });
}
document.addEventListener('DOMContentLoaded', initAllSwipers);

const gallerySliderContainer = document.querySelector('.gallery_slider');
let gallerySlider;

if (gallerySliderContainer) {
    gallerySlider = new Swiper('.gallery_slider', {
        slidesPerView: 1.3,
        spaceBetween: 20,
        navigation: {
            nextEl: ".gallery_arrow.next-arrow",
            prevEl: ".gallery_arrow.prev-arrow",
        },
        breakpoints: {

            769: {
                slidesPerView: 1,
                spaceBetween: 0,
            }
        },
    });
}

const cardsCarouselContainer = document.querySelector('.cards_carousel');
let cardsCarousel;

if (cardsCarouselContainer) {
    cardsCarousel = new Swiper('.cards_carousel', {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        speed: 1600,
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination-cards-carousel",
            clickable: true,
            renderBullet: function (index, className) {
                var title = document.querySelectorAll('.card')[index].getAttribute('data-title');
                return '<div class="' + className + '"><span>' + title + '</span></div>';
            },
        }
    });
}